var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _circle2, _circle3, _path9, _path0, _ellipse3, _ellipse4, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle4, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNinaAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 72,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 236,
    r: 176,
    fill: "url(#halo)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 220C118 167 143 124 186 106C203 84 228 72 258 72C290 72 319 86 336 111C381 130 408 173 408 224C408 252 399 278 382 300C374 262 354 239 327 228C300 216 270 213 239 215C214 216 188 223 168 239C149 254 135 276 128 303C121 289 118 256 118 220Z",
    fill: "#472417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142 211C132 191 136 167 154 154C140 133 147 105 170 95C193 85 219 95 230 116C238 94 262 80 286 86C310 93 325 115 322 138C345 127 373 136 386 158C399 180 394 209 374 224C391 240 394 267 381 286C367 306 341 315 319 307C320 331 303 353 278 359C253 365 228 353 217 331C205 351 179 360 155 351C131 342 117 317 121 293C98 294 78 279 73 255C68 231 80 207 100 198C114 191 129 195 142 211Z",
    fill: "#6A3321"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201 131C169 158 155 194 161 237C195 216 236 205 281 206C316 207 348 214 374 230C379 193 368 160 339 133C319 114 291 104 258 104C234 104 214 112 201 131Z",
    fill: "#7B412B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186 240C186 180 217 135 256 135C295 135 326 180 326 240V272C326 333 295 377 256 377C217 377 186 333 186 272V240Z",
    fill: "#FFD8BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183 263C170 257 156 264 152 279C147 294 156 310 170 313C184 317 197 307 199 293C201 280 194 268 183 263Z",
    fill: "#F0B79A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M329 263C342 257 356 264 360 279C365 294 356 310 342 313C328 317 315 307 313 293C311 280 318 268 329 263Z",
    fill: "#F0B79A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211 231C222 223 237 222 248 229",
    stroke: "#6F3828",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264 229C275 222 290 223 301 231",
    stroke: "#6F3828",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224,
    cy: 255,
    rx: 10,
    ry: 13,
    fill: "#2C1C18"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288,
    cy: 255,
    rx: 10,
    ry: 13,
    fill: "#2C1C18"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 250,
    r: 3,
    fill: "#FFF8F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 250,
    r: 3,
    fill: "#FFF8F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256 263C249 277 246 291 248 304C253 307 260 307 265 304",
    stroke: "#E5A989",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M226 323C245 337 268 338 287 323",
    stroke: "#D06D82",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201,
    cy: 287,
    rx: 14,
    ry: 8,
    fill: "#F19CB0",
    fillOpacity: 0.65
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311,
    cy: 287,
    rx: 14,
    ry: 8,
    fill: "#F19CB0",
    fillOpacity: 0.65
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M180 392C191 346 219 317 256 317C293 317 321 346 332 392L343 438H169L180 392Z",
    fill: "#FFC94D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222 333C232 349 246 358 256 360C266 358 280 349 290 333L318 356L297 438H215L194 356L222 333Z",
    fill: "#FFF1A8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210 382C224 392 239 398 256 399C273 398 288 392 302 382",
    stroke: "#F0AF1C",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185 187C175 162 180 139 198 122",
    stroke: "#4C281A",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M327 182C337 158 333 136 316 118",
    stroke: "#4C281A",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149 159C146 138 154 122 173 111",
    stroke: "#4C281A",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M363 161C366 140 358 123 340 111",
    stroke: "#4C281A",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 128,
    r: 25,
    fill: "#FFF1A3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M384 110V146",
    stroke: "#F1B62A",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M366 128H402",
    stroke: "#F1B62A",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M371 115L397 141",
    stroke: "#F1B62A",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M397 115L371 141",
    stroke: "#F1B62A",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 58,
    y1: 44,
    x2: 447,
    y2: 465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFD07D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 210) rotate(90) scale(220)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7D7",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinaAvatar);
export default __webpack_public_path__ + "static/media/nina-avatar.78e84797f142e8a2f457c78815687c01.svg";
export { ForwardRef as ReactComponent };